export const InputFormGroup = "default";

export enum SubmitButtonMode {
  DISABLE_TILL_VALID,
  ENABLE_TILL_CLICKED,
}
